import type { ReceiptTemplate } from '../schema';

export const upsTemplate: ReceiptTemplate = {
  id: 'ups',
  name: 'UPS Receipt',
  brand: 'UPS',
  description: 'UPS shipping receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ups-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/ups.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'THE UPS STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ups-tracking',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TRACKING #:\n1Z847291034567890',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: true,
      },
    },
    {
      id: 'ups-service',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'service', label: 'Service:', value: 'GROUND' },
          { id: 'weight', label: 'Weight:', value: '3.2 lbs' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'delivery', label: 'Est Del:', value: '01/09/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ups-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'shipping', label: 'SHIPPING', value: '12.99', isBold: false, isLarge: false },
          { id: 'insurance', label: 'INSURANCE', value: '2.50', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.28', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '16.77', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ups-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ups-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TRACK AT UPS.COM\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

